import React from 'react'
import PropTypes from 'prop-types'

import { fetchPageBySlug } from '~/api'
import StaticPageLayout from '~/components/StaticPageLayout'
import { isMobileDeviceType } from '~/helpers/utils'

/**
 * Constants
 */

const PAGE_SLUG = 'politica-de-privacidad'

/**
 * getServerSideProps
 */

export async function getServerSideProps({ res, req }) {
  res.setHeader('Cache-Control', 's-maxage=300, stale-while-revalidate')

  const data = await fetchPageBySlug(PAGE_SLUG)
  const isMobile = isMobileDeviceType(req)

  return { props: { data, isMobile } }
}

/**
 * PrivacyPolicy
 */

const PrivacyPolicy = ({ data, isMobile }) => <StaticPageLayout data={data} isMobile={isMobile} />

/**
 * PropTypes
 */

PrivacyPolicy.propTypes = {
  data: PropTypes.object,
  isMobile: PropTypes.bool,
}

/**
 * Exports
 */

export default PrivacyPolicy
